export const LineGutter = ({ count }: { count: number }) => (
  <div aria-hidden className="select-none text-center text-foreground-subtle bg-muted px-1.5">
    {Array.from({ length: Math.max(1, count) }).map((_, index) => (
      <div key={index} className="leading-6">
        {index + 1}
      </div>
    ))}
  </div>
);
